// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"e7beacfd","212":"4af02abf","396":"84f13bca","421":"25b1d5ea","655":"d3e4275c","996":"875cb0eb"}[chunkId] + ".chunk.css";
};